<mat-expansion-panel hideToggle class="mat-elevation-z0 project-expansion-panel" expanded>
  <mat-expansion-panel-header #expansionPanel (click)="expansionPanel._toggle()">
    <mat-panel-title class="expansion-title">
      <div class="left-section" (click)="expansionPanel._toggle()">
        <span class="expansion-icon">
          <img src="assets/images/icons/expansion-arrow-black.svg" alt="Arrow" height="24" width="24" />
        </span>
        <div class="expansion-title">{{expansionTitle}}</div>
        <app-tag [title]="totalCards"></app-tag>
        <button mat-flat-button class="filter-btn" aria-label="Sort" *ngIf="expansionTitle === projectSections.OtherProjects" [matMenuTriggerFor]="sortProjectsMenu" (click)="$event.stopPropagation()">
          <img src="./assets/images/icons/sort.svg" alt="list view" />Sort
        </button>
        <mat-menu #sortProjectsMenu="matMenu">
          <div class="menu-icon-wrapper">
            <button mat-menu-item [ngClass]="{'active-sort-menu': selectedSort === menu.name}" *ngFor="let menu of sortProjectsMenuValue" (click)="updateTileViewSortValue(menu)">
              <div class="menu-icon-list">
                <div class="menu-icon-container">
                  <img src="assets/images/icons/sort.svg" alt="Arrow" *ngIf="(menu.id === 1 || menu.id === 2)" class="menu-icon" />
                  <img src="assets/images/icons/calender.svg" alt="Arrow" *ngIf="(menu.id === 3 || menu.id === 4)" class="menu-icon" />
                  <span class="vertical-dot-menu-text-font">
                    {{menu.name}}
                  </span>
                </div>
              </div>
            </button>
          </div>
        </mat-menu>
      </div>
      <div class="right-section" *ngIf="isPaggination">
        <!--Project card Pagination-->
        <span class="tile-pagination">{{navigatedPages}} of {{totalCards}}</span>
        <!--Project card pagination navigation buttons-->
        <button mat-button aria-label="left" class="icon-button" (click)="currentPage !== 1 && changePage(-1)" [disabled]="currentPage === 1">
          <img src="assets/images/icons/arrows-left.svg" alt="Left Arrow" />
        </button>
        <button mat-button aria-label="right" class="icon-button" (click)="currentPage !== totalPages && changePage(+1)"
                [disabled]="currentPage === totalPages  || totalCards === 0">
          <img src="assets/images/icons/arrows-right.svg" alt="Right Arrow" />
        </button>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <!--Project card Slider-->
  <div #container>
    <div class="cards" [ngClass]="{'w-100': totalPages === 1}">
      <div class="overflow" [ngStyle]="{'width': overflowWidth, 'left': pagePosition}">
        <div *ngFor="let project of projects" class="tile-card" [ngStyle]="{'width': cardWidth}">
          <app-project-tile [project]="project"></app-project-tile>
        </div>
      </div>
    </div>
  </div>
</mat-expansion-panel>
